import { ReportHandler } from 'web-vitals';

/**
 * Sends web performance metrics to the provided function.
 *
 * @param onPerfEntry - The function to send the metrics to.
 * If not provided, the metrics will not be sent anywhere.
 *
 * @example
 * reportWebVitals((PERF_DATA) => {
 *   // Do something with the web performance metrics
 * });
 */
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
